
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Classical Vocal</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm employee-sports">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Classical And Semi Classical <span > Vocal Recital</span></h2>
        </div>
        <div class="row mt-5">
            <div class="col-lg-9">
                <div class=" text-justify">
                    <h2 class="head-lea">MS. KAKOLI MUKHERJEE <span class="small-sm">20 SEPTEMBER 2019</span></h2>
                    <p>Kakoli Mukherjee belongs to a family of singers and started taking lessons when she was just
                        three. Her mother was her first guru, and she taught her to love and respect music right from
                        the very beginning. When Kakoli completed her primary education, she was enrolled under Bimal
                        Ghosh, a profound singer who specialises in Indian classical music and Nazrul geeti. 'I
                        developed my skills in singing Indian classical, Nazrul sangeet, Dadra, Thumri and belonged to
                        the Kirana Gharana. I was extremely passionate about the classical music and he indeed increased
                        my affinity towards it with time,' explains Kakoli. Uday Majumdar was her third guru and Kakoli
                        owes a great deal of her success to him. A gold medalist in classical singing, Kakoli makes sure
                        that she indulges herself into at least four-hour 'riyaaz' every day.</p>

                </div>
            </div>
            <div class="col-md-3">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kakoli-mukherjee.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>

        <div class="col-lg-12">
            <p>Today, Kakoli holds an affiliation to the Prachin Kala Kendra, Chandigarh under which her students can
                appear for examinations and earn certificates in singing. Kakoli Mukherjee started with just five
                students and today she has more than 30 pupils. She teaches every form of music, Adhunik, Bhajans,
                Nazrul geeti and of course Indian classical music.</p>
            <p>On 20th September @ 7.00 Pm. Ms. Kakoli Mukherjee in the Classical Conclave session at Chitnavis Centre
                Nagpur.</p>
        </div>
        <div class="border-line-sm"></div>
        <div class="row">
            <div class="col-lg-9">
                <h6 class="fw-bold">Let’s meet you then.</h6>
                <p class="fw-bold"> Classical and Semi Classical Vocal Recital</p>
                <p>Artist : Ms. Kakoli Mukherjee</p>
                <p>Harmonium : Shrikant Pise</p>
                <p>Tabla : Ram Khadse</p>
                <p>Date : 20<sup>th</sup> September 2019</p>
                <p>Time : 7.00 Pm</p>
                <p>Venue : Chitnavis Centre, Besides Hislop College, Civil Lines Nagpur.</p>
            </div>
            <div class="col-md-3">
                <div class="image-effect-3">
                    <h6 class="fw-bold"> INVITATION</h6>
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kakoli-invitation.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>
        <div class="border-line-sm"></div>

        <div class="row row-cols-1 row-cols-md-3">
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Media Coverage</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Videos</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>

                </div>
                <iframe width="100%" height="230" src="https://www.youtube.com/embed/mCeo78jfyP8" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Photos</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="photogallery#aditi-upadhya" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/km-1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/km-1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/km-1.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/km-1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/km-1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/km-1.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
</section>
